<template>
    <div
        v-if="isVisible"
        :class="['dropdown-menu', animationClass]"
        class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white ring-1 shadow-lg ring-black/5 focus:outline-hidden"
        role="menu"
        >
        <div class="py-1" role="none">
            <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem">Bouguets</a>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem">Shops</a>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem">Contact</a>
          </div>
    </div>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isVisible: this.isOpen,
            animationClass: '',
        };
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                // Opening the menu
                this.animationClass = 'animate__animated animate__fadeInUp';
                this.isVisible = true; // Make the menu visible
            } else {
                // Closing the menu
                this.animationClass = 'animate__animated animate__fadeOutDown';
                setTimeout(() => {
                    this.isVisible = false; // Hide the menu after the animation
                }, 300); // Matches the animation duration
            }
        },
    },
}
</script>